import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Loader from '../../Components/Loader/Loader';
import { serviceConsumer } from '../../network/ServiceConsumer';
import Help from '../../Components/Help/Help';
import EventSite from '../EventSite/EventSite';
import { sortGrades } from '../../helper/SortSyllabus';
import { isEventToday, pageStateForEvent } from '../../helper/eventFeed';
import { useDispatch } from 'react-redux';
import { setConversionRate } from '../Register-Events/helper';
import EntryCard from '../../Components/EntryCard/EntryCard';
import { cardActions, entriesFrom, notEnteredIn } from '../../Components/EntryCard/entryCardModel';


const ViewGradeEdit = () => {
  const [loading, setLoading] = useState(false);
  const [event, setEvent] = useState()
  const [collaborators, setCollaborators] = useState([])
  const [dancers, setDancers] = useState([])
  const [family, setFamily] = useState([])

  const navigate = useNavigate();
  const dispatch = useDispatch()

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search)
  const eventId = searchParams.get('id')

  const getAllDetails = async () => {
    try {
      setLoading(true)
      const url = `${process.env.REACT_APP_BASE_URL}/grade-exam/registered/dancers/${eventId}`
      const response = await serviceConsumer("GET", url)
      setConversionRate(dispatch,response?.eventData?.usdExchangeRate)
      setEvent(response?.eventData)
      setDancers(response?.result)

      const collaboratorsUrl = `${process.env.REACT_APP_BASE_URL}/grade-exam/collaborators/${eventId}`
      const collaboratorsResponse = await serviceConsumer('GET', collaboratorsUrl)
      setCollaborators(collaboratorsResponse.result)
      // the family's dancers: "Enter another dancer" only when one isn't entered yet
      serviceConsumer('GET', `${process.env.REACT_APP_BASE_URL}/account/dancers`)
        .then((r) => setFamily(r?.dancers || []))
        .catch(() => {})
      setLoading(false)
    }
    catch (error) {
      navigate("pageNotFound", { replace: true })
      setLoading(false)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllDetails()
  }, []);

  useEffect(() => {
    if (event?.name) document.title = `Feis.link - ${event.name}`;
  }, [event]);

  //button handlers
  const backToViewEvent = () => {
    navigate('/parent');
  };

  // the family's entry card, the same as on the dashboard (MC2 ecbc86f7)
  const pageState = pageStateForEvent(event && { ...event, eventType: "Grade Exam" });
  const today = isEventToday(event && { ...event, eventType: "Grade Exam" });
  const entries = entriesFrom(dancers, {
    kind: "grade",
    event,
    onChange: (reg) => navigate(`/grade-edit-dancers/${event._id}?regId=${reg._id}`, { state: { event } }),
  });
  const actions = cardActions({
    event,
    kind: "grade",
    notEntered: notEnteredIn(family, dancers),
    go: {
      open: (url) => window.open(url, "_blank", "noopener,noreferrer"),
      add: () => navigate(`/register-grade-exam?id=${event._id}`, { state: { event } }),
    },
  });

  return (
    <div>
      {loading && <Loader />}
      {!loading && event && (
        <EventSite
          event={event}
          kind="grade"
          state={today ? "today" : pageState}
          entered
          dancerCount={dancers?.length || 0}
          collaborators={collaborators}
          grades={sortGrades(collaborators?.grades || [])}
          onBack={backToViewEvent}
          card={<EntryCard event={event} kind="grade" today={today} entries={entries} actions={actions} />}
        />
      )}
      <Help />
    </div>
  );
};

export default ViewGradeEdit;
